import React, { Component } from "react";
import userService from "../../services/userService";
import CircularLoadingScreen from "../commons/CircularLoadingScreen";
import NotFound from "../NotFound";
import User from "../commons/User";
import SimpleBar from "simplebar-react";
import "../../resources/admin.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import postService from "../../services/postService";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { withSnackbar } from "../../hocs/withSnackbar";
import { format } from "date-fns";
import Username from './Username';

class AdminDashboard extends Component {
  state = {
    usersAccordionOpen: false,
    loadedUsers: false,
    users: [],
    showNotFound: false,
    loadedPostStatistics: false,
    postStatistics: {},
    postStatisticsCode: "week",

    loadedUserStatistics: false,
    userStatistics: {},
    userStatisticsCode: "week",

    ticketsAccordionOpen: false,
    loadedTickets: false,
    tickets: [],
  };

  async componentDidMount() {
    const currentUser = userService.getCurrentUser();
    if (!currentUser.isAdmin) {
      this.setState({
        showNotFound: true,
      });
    } else {
      await this.loadPostStatistics();
      await this.loadUserStatistics();
    }
  }

  parseStatistics(data) {
    const entries = Object.entries(data);
    const statistics = entries
      .map(([key, value]) => ({
        name: key,
        count: value,
      }))
      .sort((a, b) => new Date(a.name) - new Date(b.name));
    return statistics;
  }

  loadPostStatistics = async () => {
    const { showMessage } = this.props;
    this.setState({
      loadedPostStatistics: false,
    });
    setTimeout(async () => {
      try {
        const { postStatisticsCode } = this.state;
        if (postStatisticsCode) {
          const response = await postService.getStatistics(postStatisticsCode);
          const statistics = this.parseStatistics(response.data.data);
          this.setState({
            loadedPostStatistics: true,
            postStatistics: statistics,
          });
        }
      } catch (err) {
        showMessage("Failed to load post statistics", "error");
      }
    }, 500);
  };

  loadUserStatistics = async () => {
    const { showMessage } = this.props;
    this.setState({
      loadedUserStatistics: false,
    });

    setTimeout(async () => {
      try {
        const { userStatisticsCode } = this.state;
        if (userStatisticsCode) {
          const response = await userService.getStatistics(userStatisticsCode);
          const statistics = this.parseStatistics(response.data.data);
          this.setState({
            loadedUserStatistics: true,
            userStatistics: statistics,
          });
        }
      } catch (err) {
        showMessage("Failed to load user statistics", "error");
      }
    }, 500);
  };

  loadUsers = async () => {
    const { showMessage } = this.props;
    setTimeout(async () => {
      try {
        const response = await userService.getUsers();
        const users = response.data.data;
        this.setState({
          loadedUsers: true,
          users,
        });
      } catch (err) {
        showMessage("Failed to load users", "error");
      }
    }, 500);
  };

  loadTickets = async () => {
    const { showMessage } = this.props;
    setTimeout(async () => {
      try {
        const response = await userService.getTickets();
        const tickets = response.data.data;
        this.setState({
          loadedTickets: true,
          tickets,
        });
      } catch (err) {
        showMessage("Failed to load tickets", "error");
      }
    }, 500);
  };

  render() {
    const {
      loadedUsers,
      users,
      showNotFound,
      usersAccordionOpen,
      loadedPostStatistics,
      postStatistics,
      postStatisticsCode,
      loadedUserStatistics,
      userStatistics,
      userStatisticsCode,
      ticketsAccordionOpen,
      loadedTickets,
      tickets,
    } = this.state;

    if (showNotFound) {
      return <NotFound />;
    }
    return (
      <div
        style={{
          padding: "0px 20px",
          paddingBottom: 20,
        }}
      >
        <h2
          className="heading"
          style={{
            marginBottom: 0,
          }}
        >
          Admin Dashboard
        </h2>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3 className="heading">New Posts Statistics</h3>
          <FormControl variant="standard">
            <Select
              value={postStatisticsCode}
              onChange={(e) => {
                this.setState({
                  postStatisticsCode: e.target.value,
                });
                this.loadPostStatistics();
              }}
              disableUnderline
              style={{
                fontFamily: "inherit",
              }}
            >
              <MenuItem value={"week"}>This Week</MenuItem>
              <MenuItem value={"month"}>This Month</MenuItem>
              <MenuItem value={"all"}>All time</MenuItem>
            </Select>
          </FormControl>
        </div>
        {loadedPostStatistics ? (
          <div
            style={{
              marginBottom: 10,
            }}
          >
            <ResponsiveContainer width="100%" height={320}>
              <LineChart data={postStatistics} width={500} height={320}>
                <XAxis dataKey="name" dy={10} />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Line type="monotone" dataKey="count" stroke="#000000" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        ) : (
          <CircularLoadingScreen thickness={5} />
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3 className="heading">New Users Statistics</h3>
          <FormControl variant="standard">
            <Select
              value={userStatisticsCode}
              onChange={(e) => {
                this.setState({
                  userStatisticsCode: e.target.value,
                });
                this.loadUserStatistics();
              }}
              disableUnderline
              style={{
                fontFamily: "inherit",
              }}
            >
              <MenuItem value={"week"}>This Week</MenuItem>
              <MenuItem value={"month"}>This Month</MenuItem>
              <MenuItem value={"all"}>All time</MenuItem>
            </Select>
          </FormControl>
        </div>
        {loadedUserStatistics ? (
          <div
            style={{
              marginBottom: 10,
            }}
          >
            <ResponsiveContainer width="100%" height={320}>
              <LineChart data={userStatistics} width={500} height={320}>
                <XAxis dataKey="name" dy={10} />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Line type="monotone" dataKey="count" stroke="#000000" />
              </LineChart>
            </ResponsiveContainer>
            <hr />
          </div>
        ) : (
          <CircularLoadingScreen thickness={5} />
        )}

        <Accordion
          open={usersAccordionOpen}
          onChange={async (event, isExpanded) => {
            this.setState({
              usersAccordionOpen: isExpanded,
              loadedUsers: !isExpanded,
            });

            if (isExpanded) {
              await this.loadUsers();
            }
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Registered users
          </AccordionSummary>
          <AccordionDetails>
            {loadedUsers ? (
              <TableContainer
                style={{
                  fontFamily: "inherit",
                }}
              >
                <Table
                  size="small"
                  style={{
                    fontFamily: "inherit",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Username</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>id</TableCell>
                      <TableCell>IP Address</TableCell>
                      <TableCell>Create date</TableCell>
                      <TableCell>Delete date</TableCell>
                      <TableCell>Banned?</TableCell>
                      <TableCell>Admin?</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users.map((user) => (
                      <TableRow key={user.id}>
                        <TableCell>{user.username}</TableCell>
                        <TableCell>{user.email}</TableCell>
                        <TableCell>{user.id}</TableCell>
                        <TableCell>{user.ipAddress}</TableCell>
                        <TableCell>{user.createDate}</TableCell>
                        <TableCell>{user.deleteDate || "n/a"}</TableCell>
                        <TableCell>{user.banned ? "Yes" : "No"}</TableCell>
                        <TableCell>{user.admin ? "Yes" : "No"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <CircularLoadingScreen thickness={5} />
            )}
          </AccordionDetails>
        </Accordion>

        <Accordion
          open={ticketsAccordionOpen}
          onChange={async (event, isExpanded) => {
            this.setState({
              ticketsAccordionOpen: isExpanded,
              loadedTickets: !isExpanded,
            });

            if (isExpanded) {
              await this.loadTickets();
            }
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            Contact tickets
          </AccordionSummary>
          <AccordionDetails>
            {loadedTickets ? (
              <>
                {tickets.map((ticket) => (
                  <div
                    style={{
                      border: "1px solid #ededed",
                      padding: "10px 20px",
                    }}
                  >
                    <h4
                      style={{
                        marginTop: 0,
                      }}
                    >
                      {ticket.title}
                    </h4>
                    <p>{ticket.body}</p>
                    <hr
                      style={{
                        opacity: 0.5,
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      By&nbsp;<Username username={ticket.author.username} style={{
                        marginRight: 0
                      }}/>&nbsp;at&nbsp;
                      <span>
                        {format(
                          new Date(ticket.createDate),
                          "hh:mm aa, MMM dd, yyyy"
                        )}
                      </span>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <CircularLoadingScreen thickness={5} />
            )}
          </AccordionDetails>
        </Accordion>
      </div>
    );
  }
}

export default withSnackbar(AdminDashboard);
